<template>
    <el-dialog :visible.sync="dialogVisible"
               custom-class="banner-dialog"
               top="30vh"
               width="300px"
               :before-close="handleClose">
        <div class="warning-warp">
            <i class="el-icon-warning-outline"></i>
            <span class="warning-text">{{ warningText }}</span>

            <!-- <span class="warning-text">确认将banner标题删除？</span> -->
        </div>
        <span slot="footer"
              class="dialog-footer">
            <el-button @click="handleConfirm">确 定</el-button>
            <el-button @click="handleClose">取 消</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: 'warningDialog',
    props: {
        warningText: {
            type: String,
            default: ''
        },
        dialogVisible: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            default: ''
        }
    },
    methods: {
        handleConfirm () {
            this.$emit('handleConfirm', this.id)
        },
        handleClose () {
            this.$emit('handleClose')
        }
    }
}
</script>

<style lang="scss">
.banner-dialog {
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    .el-dialog__header {
        padding: 10px 0;
        background: #fff;
        .el-dialog__headerbtn {
            top: 5px;
            right: 10px;
            .el-icon-close {
                color: #ccc;
                font-size: 12px;
            }
        }
    }
    .el-dialog__body {
        padding: 10px 0 30px 26px;
        .warning-warp {
            display: flex;
            align-items: center;
            .el-icon-warning-outline {
                font-size: 20px;
                color: #fdab71;
            }
            .warning-text {
                margin-left: 12px;
                font-family: PingFangSC-Semibold;
                font-size: 14px;
                color: #333333;
                letter-spacing: 0;
                text-align: left;
                line-height: 14px;
                font-weight: bold;
            }
        }
    }
    .el-dialog__footer {
        padding: 0 0 18px 57px;
        .el-button {
            padding: 0;
            width: 90px;
            height: 26px;
        }
    }
}
</style>
